import Request from './request';

async function fetch(data) {// 退框一览
    return Request('get', "api/return-baskets/index", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/return-baskets/view/" + id, data);
}

async function getRefundableBaskets(data) {
    return Request('get', "api/return-baskets/get-refundable-baskets/", data);
}

async function generateReturnOrder(data) {
    return Request('post', "api/return-baskets/generate-return-order/", data);
}

async function getRefundableShops() {
    return Request('post', "api/return-baskets/get-refundable-shops/");
}



export default {
    fetch,
    fetchOne,
    getRefundableBaskets,
    generateReturnOrder,
    getRefundableShops,
};